import React from "react";
import WrapupModuleWelcome from "./modules/welcome";
import IWrapupModule from "./modules/imodule";
import { DialogStep } from "@blueprintjs/core";
import { GetWrapupType } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import WrapupModulePlays from "./modules/plays";
import WrapupModuleKills from "./modules/kills";
import WrapupModuleKillsContinued from "./modules/killscontd";
import WrapupModuleMaps from "./modules/map";
import WrapupModuleMapsContinued from "./modules/mapcontinued";
import WrapupModuleCombat from "./modules/combat";
import WrapupModuleTeams from "./modules/teams";
import WrapupModuleKillsContinued2 from "./modules/killscontd2";
import WrapupModuleFinale from "./modules/finale";

const MODULES: IWrapupModule[] = [
    new WrapupModuleWelcome(),
    new WrapupModulePlays(),
    new WrapupModuleMaps(),
    new WrapupModuleMapsContinued(),
    new WrapupModuleCombat(),
    new WrapupModuleKills(),
    new WrapupModuleKillsContinued(),
    new WrapupModuleKillsContinued2(),
    new WrapupModuleTeams(),
    new WrapupModuleFinale(),
];

export default function getWrapupDialogPanels(
    wrapupData: GetWrapupType,
): React.ReactNode {
    return MODULES
        .filter(
            (module) => module.canRender(wrapupData),
        )
        .map(
            (module) => (
                <DialogStep
                    key={module.id}
                    id={module.id}
                    title={module.name}
                    panel={React.createElement(module.getComponentClass())}
                />
            ),
        );
}
